import React, { ReactElement } from 'react'
import styled from 'styled-components'
import { FooterMenuItem } from '../../footer.props'

export const MenuList = ({ menus, renderMenu }: MenuListProps) => {
  return (
    <section>
      <List>
        {menus.map((item) => (
          <MenuContainer
            key={`${item.url}__${item.label}`}
            justifyCenter={item?.isCentered}
          >
            {renderMenu(item)}
          </MenuContainer>
        ))}
      </List>
    </section>
  )
}

type MenuListProps = {
  menus: FooterMenuItem[]
  renderMenu: (menu: FooterMenuItem) => ReactElement
}

const List = styled.ul.attrs({
  className: 'row',
})``

const MenuContainer = styled.li.attrs({
  className: 'col-12 col-lg-4',
})<{ justifyCenter?: boolean }>`
  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    ${({ justifyCenter }) =>
      justifyCenter &&
      `
    display: flex;
    justify-content: center;
  `}
  }
`
